import React from 'react'

const ProjectSummary = ({ projects }) => {
  const date = new Date(projects.data.createdAt.seconds*1000);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

  const dayNames = ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat",
  "Sun" ];

  console.log(date)
  return (
    <div className="card z-depth-0 project-summary">
      <ul className="collection">
        <div className="card-content grey-text text-darken-3">
          <li className="collection-item avatar">
            <img style={{ top: '15%' }}src={projects.data.url} alt="" class="circle" />
            <span style={{ marginBottom: '4px' }} className="card-title ">{projects.data.title}</span>
            <p style={{ marginBottom: '2px' }}>Posted by {projects.data.firstName} {projects.data.lastName}</p>
            <p className="grey-text"> Created at :- {dayNames[date.getDay()]} {date.getDate()} {monthNames[date.getMonth()]} {date.getFullYear()} </p> 
          </li>
        </div>
      </ul>
    </div>

  )
}

export default ProjectSummary